import Drawer from 'components/drawer';
import { formatCurrency } from 'libs';
import React from 'react';
import styles from './products.module.scss';
export default function ProductCommission({
  details,
  drawerActive,
  setDrawerActive,
}) {
  const { pricing } = details;

  const renderAmountRange = (value) => {
    let amountRange = value.split(',');

    return (
      <div data-testid="range">
        {amountRange.map((item, index) => {
          let field = item.split(':');
          let label = field[0].split('-');
          let value = field[1];

          return (
            <div className={styles.transactionDetails__range} key={index}>
              <p className={styles.transactionDetails__text}>{`${formatCurrency(
                parseInt(label[0]),
              )}   -  ${formatCurrency(parseInt(label[1]))} `}</p>

              <p className={styles.transactionDetails__value}>
                {` ${formatCurrency(parseInt(value))}`}
              </p>
            </div>
          );
        })}
      </div>
    );
  };

  const rangeAmt = pricing?.amount.split(',');

  const pName =
    pricing?.type === 'percentage_and_flat'
      ? pricing?.type.replaceAll('_', ' ')
      : pricing?.type;

  return (
    <Drawer
      title={`${pName !== undefined ? pName : ''} Commission`}
      setDrawerActive={setDrawerActive}
      drawerActive={drawerActive}
    >
      <Drawer.DrawerBody>
        <div data-testid="comm">
          {pricing?.type === 'fixed' ? (
            <div
              className={styles.transactionDetails__gender__wrapper}
              data-testid="fixed"
            >
              <div className={styles.transactionDetails__gender}>
                <p className={styles.transactionDetails__text}>Commission</p>
                <p className={styles.transactionDetails__value}>
                  {formatCurrency(parseInt(pricing.amount))}
                </p>
              </div>
            </div>
          ) : pricing?.type === 'percentage' ? (
            <div
              className={styles.transactionDetails__gender__wrapper}
              data-testid="percentage"
            >
              <div className={styles.transactionDetails__gender}>
                <p className={styles.transactionDetails__text}>Commission</p>
                <p className={styles.transactionDetails__value}>
                  {`${pricing.amount}%`}
                </p>
              </div>
            </div>
          ) : pricing?.type === 'range' ? (
            <>{renderAmountRange(pricing.amount)}</>
          ) : pricing?.type === 'percentage_and_flat' ? (
            <div
              className={styles.transactionDetails__gender__wrapper}
              data-testid="percentage_and_flat"
            >
              <div className={styles.transactionDetails__gender}>
                <p className={styles.transactionDetails__text}>Commission</p>
                <p className={styles.transactionDetails__value}>
                  {formatCurrency(parseInt(rangeAmt[0]))} + {rangeAmt[1]}%
                </p>
              </div>
            </div>
          ) : (
            <p>There is no commission to see here yet 😉</p>
          )}
        </div>
      </Drawer.DrawerBody>
    </Drawer>
  );
}
